import _ from 'lodash';
import initialState from './initialState.js';
import constants from '../helpers/constants.js';

export default function modalPopupReducer(state = initialState.modalPopup, action) {
    switch (action.type) {
        case constants.UPDATE_MODAL_POPUP_STATUS:
            return Object.assign({}, state, action.data);
        case constants.UPDATE_MODAL_POPUP_CLOSE:
            return Object.assign({}, state, { defaultOpen: false });
        default:
            return state;
    }
}
